import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { X } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (isDismissed) return null;
  return <div className={`fixed bottom-4 left-4 right-4 z-50 md:hidden transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'}`} data-id="element-402">
      <div className="relative" data-id="element-403">
        {/* Mascot Peeking */}
        <img src="https://cdn.magicpatterns.com/uploads/oRjVdEwcjrJByMjpUoNSga/cute-colour-inkling.png" alt="Mascot" className="absolute -top-12 -left-2 w-16 h-auto drop-shadow-lg z-10 animate-float" data-id="element-404" />

        {/* Close Button */}
        <button onClick={() => setIsDismissed(true)} className="absolute -top-2 -right-2 bg-gray-900 text-white rounded-full p-1 shadow-md z-20" data-id="element-405">
          <X className="h-3 w-3" data-id="element-406" />
        </button>

        <Button fullWidth size="lg" className="shadow-xl border-2 border-white/20 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700" onClick={() => document.getElementById('quote')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-407">
          Get a Free Quote
        </Button>
      </div>
    </div>;
}